import { render, staticRenderFns } from "./AdminTableDeleteButton.vue?vue&type=template&id=60b38f58&scoped=true&"
import script from "./AdminTableDeleteButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b38f58",
  null
  
)

export default component.exports